export { ValidateTreeView, CreateTreeViewObject, CreateLocationsItems, GetOptionIdsForOptionPaths };

function CreateLocationsItems(locationTree, publicHolidayType) {
  var locationItems = [];
  if ("cantons" in locationTree && locationTree.cantons.length) {
    locationTree.cantons.forEach(canton => {
      if (canton.selected) {
        locationItems.push({
          cantonId: canton.cantonId,
          id: 0,
          publicHolidayType: publicHolidayType,
          ressourceCalendarId: 0,
          validForCH: false
        });
      }

      if ("districts" in canton && canton.districts.length) {
        canton.districts.forEach(district => {
          if (district.selected) {
            locationItems.push({
              id: 0,
              ressourceCalendarId: 0,
              publicHolidayType: publicHolidayType,
              validForCH: false,
              cantonId: canton.cantonId,
              districtId: district.districtId
            });
          }

          if ("cities" in district && district.cities.length) {
            district.cities.forEach(city => {
              if (city.selected) {
                locationItems.push({
                  id: 0,
                  ressourceCalendarId: 0,
                  publicHolidayType: publicHolidayType,
                  validForCH: false,
                  cantonId: canton.cantonId,
                  districtId: district.districtId,
                  cityId: city.cityId
                });
              }
            });
          }
        });
      }
    });
  }
  return locationItems;
}

function CreateTreeViewObject(
  options,
  selectedIds,
  configurationId,
  publicHolidayType
) {
  const result = {
    forCH: false,
    configurationId: configurationId,
    publicHolidayType: publicHolidayType,
    cantons: []
  };

  // Iteriere über die Cantons in den Options
  for (const cantonOption of options) {
    const cantonId = cantonOption.id;
    const cantonSelected = selectedIds.includes(cantonId);

    const cantonObject = {
      cantonId,
      selected: cantonSelected,
      districts: []
    };

    // Wenn der Kanton ausgewählt ist oder ein darunterliegendes Element ausgewählt ist,
    // iteriere über die Districts

    for (const districtOption of cantonOption.children) {
      const districtId = parseInt(districtOption.id.split("_").pop(), 10);
      const districtSelected = selectedIds.includes(districtOption.id);

      const districtObject = {
        districtId,
        selected: districtSelected,
        cities: []
      };

      // Wenn der District ausgewählt ist oder ein darunterliegendes Element ausgewählt ist,
      // iteriere über die Cities
      if (
        districtSelected ||
        districtOption.children.some(city => selectedIds.includes(city.id))
      ) {
        for (const cityOption of districtOption.children) {
          const cityId = parseInt(cityOption.id.split("_").pop(), 10);
          const citySelected = selectedIds.includes(cityOption.id);

          const cityObject = {
            cityId,
            selected: citySelected
          };

          // Füge das City-Objekt zum District-Objekt hinzu, wenn city ausgewählt wurde
          if (citySelected) {
            districtObject.cities.push(cityObject);
          }
        }
      }

      // Füge das District-Objekt zum Canton-Objekt hinzu, nur wenn der District ausgewählt ist
      if (districtSelected || districtObject.cities.length > 0) {
        //Wenn alle cities ausgewählt werden, muss das array leer sein
        if (districtObject.cities.filter(x => x.selected).length === districtOption.children.length) {
          districtObject.cities = [];
        }

        cantonObject.districts.push(districtObject);
      }
    }

    // Füge das Canton-Objekt zum Ergebnisobjekt hinzu, auch wenn keine Districts oder Cities ausgewählt sind
    if (cantonSelected || cantonObject.districts.length > 0) {
      //Wenn alle bezirke ausgewählt werden, muss das array leer sein
      if (cantonObject.districts.filter(x => x.selected).length === cantonOption.children.length) {
        cantonObject.districts = [];
      }

      result.cantons.push(cantonObject);
    }
  }

  if (options.length === result.cantons.length) {
    result.cantons = [];
    result.forCH = true;
  }
  return result;
}

//Creat Tree View for Cantons
function ValidateTreeView(cantonDistrictCityData, shutoff = true) {
  var firstLevelTreeView = createValidatedTreeView(cantonDistrictCityData, shutoff);
  return firstLevelTreeView;
}

function createValidatedTreeView(cantonDistrictCityData, filter = [], shutoff = true) {
  var treeItems = [];
  var selectedTreeItems = [];
  var currentCanton = 0;
  var currentDistrict = 0;
  var locationTree = [
    {
      id: "CH",
      name: "CH",
      path: "CH",
      children: [],
      selected: cantonDistrictCityData.forCH
    }
  ];

  if (cantonDistrictCityData.forCH) {
    selectedTreeItems.push("CH");
  }

  if (cantonDistrictCityData.cantons) {
    cantonDistrictCityData.cantons.forEach(canton => {
      // Canton level TreeView
      var topLevelTreeViewItem = {
        id: canton.cantonId,
        name: canton.canton
          ? canton.canton
          : canton.cantonName + " (" + canton.cantonCode + ")",
        path: `CH/${canton.cantonCode}`,
        children: [],
        shutoff: shutoff,
        selected: canton.selected
      };

      // Manage Cantons - Insert if not already exists
      if (currentCanton !== canton.cantonId) {
        currentCanton = canton.cantonId;
        const isObjectValid = filter.length > 0 ? filter.some(x => x.cantonId === currentCanton): true;
        const isObjectAlreadyInArray = treeItems.some(
          item =>
            // Customize this condition based on the properties that make an object unique
            item.id === topLevelTreeViewItem.id
        );

        if (!isObjectAlreadyInArray && isObjectValid) {
          treeItems.push(topLevelTreeViewItem);

          // District level
          if (canton.districts && canton.districts.length) {
            canton.districts.forEach(district => {
              // District level TreeView
              var secondLevelTreeViewItem = {
                id: canton.cantonId + "_" + district.districtId,
                path: `CH/${canton.cantonCode}/${district.districtCode}`,
                name: district.districtName,
                children: [],
                shutoff: shutoff,
                selected: district.selected
              };

              // Manage District - Insert if not already exists
              if (currentDistrict !== district.districtId) {
                currentDistrict = district.districtId;

                const isObjectValid = filter.length > 0 ? filter.some(x => x.districtId === currentDistrict) : true;
                const isObjectAlreadyInArray = treeItems[
                  treeItems.length - 1
                ].children.some(
                  item =>
                    // Customize this condition based on the properties that make an object unique
                    item.id === secondLevelTreeViewItem.id
                );

                if (!isObjectAlreadyInArray && isObjectValid) {
                  treeItems[treeItems.length - 1].children.push(
                    secondLevelTreeViewItem
                  );

                  // City level
                  if (district.cities && district.cities.length) {
                    district.cities.forEach(city => {
                      // City level TreeView
                      var thirdLevelTreeViewItem = {
                        id:
                          canton.cantonId +
                          "_" +
                          district.districtId +
                          "_" +
                          city.cityId,
                        path: `CH/${canton.cantonCode}/${district.districtCode}/${city.cityCode}`,
                        name: city.plz + " " + city.cityName,
                        shutoff: shutoff,
                        selected: city.selected
                      };

                      // Manage Cities - Insert if not already exists
                      const lastChildrenArray =
                        treeItems[treeItems.length - 1].children[
                          treeItems[treeItems.length - 1].children.length - 1
                        ].children;

                      const isObjectValid = filter.length > 0 ? filter.some(x => x.cityId === city.cityId) : true;
                      const isObjectAlreadyInArray = lastChildrenArray.some(
                        item =>
                          // Customize this condition based on the properties that make an object unique
                          item.id === thirdLevelTreeViewItem.id
                      );

                      if (!isObjectAlreadyInArray && isObjectValid) {
                        lastChildrenArray.push(thirdLevelTreeViewItem);
                      }

                      if (city.selected) {
                        if (
                          !selectedTreeItems.includes(
                            secondLevelTreeViewItem.path
                          )
                        ) {
                          selectedTreeItems.push(thirdLevelTreeViewItem.path);
                        }
                      }
                    });
                  }
                }
              }

              if (district.selected) {
                if (!selectedTreeItems.includes(secondLevelTreeViewItem.path)) {
                  selectedTreeItems.push(secondLevelTreeViewItem.path);
                }
              }
            });
          }
        }
      }

      if (canton.selected) {
        if (!selectedTreeItems.includes(topLevelTreeViewItem.path)) {
          selectedTreeItems.push(topLevelTreeViewItem.path);
        }
      }
    });
  }

  locationTree[0].children = treeItems;

  locationTree.forEach(sortByName);

  return {
    treeItems: locationTree,
    selectedItems: selectedTreeItems
  };
}

function GetOptionIdsForOptionPaths(options, paths) {
  let selectedLocationIds = [];
  paths.forEach(locationPath => {
    let pathPieces = locationPath.split("/");
    if(pathPieces.length == 1){
      selectedLocationIds.push(locationPath)
    }
    if(pathPieces.length == 2){
      let cantonNode = options.find(cant => cant.path == locationPath);
        if(cantonNode){
        selectedLocationIds.push(cantonNode.id)
        }
    }
    if(pathPieces.length == 3){
      let cantonNode = options.find(cant => locationPath.includes(cant.path));
      if(cantonNode){
        let districtNode = cantonNode.children.find(dist => dist.path == locationPath);
        if(districtNode){
          selectedLocationIds.push(districtNode.id)
        }
      }
    }
    if(pathPieces.length == 4){
      let cantonNode = options.find(cant => locationPath.includes(cant.path));
      if(cantonNode){
        let districtNode = cantonNode.children.find(dist => locationPath.includes(dist.path));
        if(districtNode){
          let cityNode = districtNode.children.find(city => city.path == locationPath);
          if(cityNode){
            selectedLocationIds.push(cityNode.id)
          }
        }
      }
    }
  });

  return selectedLocationIds;
}

function sortByName(item) {
  if (item.children) {
    item.children.sort((a, b) => a.name.localeCompare(b.name));
    item.children.forEach(sortByName);
  }
}
